import { traitButton } from './shared';
import { CMD_OPEN_TEXT_EDITOR } from './../../const/commands';

export const TextEditor = function(editor, options:any = {}) {
    return {
        name: options.name,
        noLabel: true,
        templateInput: '',
        getInputEl() {
            return traitButton({
                editor: editor,
                buttonText: 'Edit Textblock',
                command: CMD_OPEN_TEXT_EDITOR
            });
        }
    }
}